module.exports = __webpack_public_path__ + "img/17logo.dde5ffc2.svg";